import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';

const LoginForm = ({ hasLabel = true }) => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleFieldChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(formData.email, formData.password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Pogrešan email ili lozinka.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      {error && (
        <div className="alert alert-danger py-2 fs-10 mb-3" role="alert">
          {error}
        </div>
      )}

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Email adresa</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Email adresa' : ''}
          value={formData.email}
          name="email"
          onChange={handleFieldChange}
          type="email"
          required
          autoFocus
        />
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Lozinka</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Lozinka' : ''}
          value={formData.password}
          name="password"
          onChange={handleFieldChange}
          type="password"
          required
        />
      </Form.Group>

      <Form.Group>
        <Button
          type="submit"
          className="mt-3 w-100"
          disabled={!formData.email || !formData.password || loading}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" />
              Prijava...
            </>
          ) : (
            'Prijavi se'
          )}
        </Button>
      </Form.Group>
    </Form>
  );
};

export default LoginForm;
